<template>
  <v-dialog v-model="dialog" max-width="400px">
    <template v-slot:activator="{ on, attrs }">
      <v-btn color="#2837bf" outlined v-bind="attrs" v-on="on">
        <v-icon left>mdi-login</v-icon>Log In
      </v-btn>
    </template>
    <v-card>
      <v-card-title>
        <span class="headline mx-auto">Connexion</span>
      </v-card-title>
      <v-divider></v-divider>
      <v-container>
        <v-row justify="center">
          <v-col cols="10">
            <v-form lazy-validation>
              <v-text-field
                v-model="email"
                :rules="emailRules"
                label="Identifiant"
                append-icon="mdi-account"
                outlined
                autofocus
                required
                @keyup.enter="logIn"
                dense
              ></v-text-field>
              <v-text-field
                v-model="password"
                label="Password"
                append-icon="mdi-lock-question"
                type="Password"
                outlined
                required
                full-width
                dense
                @keyup.enter="logIn"
              ></v-text-field>
              <v-spacer></v-spacer>
              <v-divider class="mb-6"></v-divider>
              <v-btn
                color="#2837bf"
                block
                dark
                @click="logIn"
                :loading="loading"
                >GO !</v-btn
              >
            </v-form>
          </v-col>
        </v-row>
        <v-snackbar
          v-model="successMessage"
          :timeout="3000"
          outlined
          color="success"
        >
          <v-icon color="success">mdi-check-circle</v-icon>
          <span class="mx-2">Connexion établie avec succès !</span>
        </v-snackbar>
        <v-snackbar
          v-model="errorMessage"
          :timeout="5000"
          outlined
          color="error"
        >
          <v-icon color="error">mdi-close-circle</v-icon>
          <span class="mx-2">Email / Mot de pass incorrect !</span>
        </v-snackbar>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      successMessage: false,
      dialog: false,
      errorMessage: false,
      email: "",
      emailRules: [
        v => !!v || "E-mail requis !",
        v => /.+@.+\..+/.test(v) || "L'adresse e-mail doit être valide!"
      ],
      password: ""
    };
  },
  methods: {
    async logIn() {
      this.loading = true;
      await this.$store.dispatch("logIn", {
        email: this.email,
        password: this.password
      });
      this.successMessage = true;
      setTimeout(() => {
        this.loading = false;
        this.dialog = false;
      }, 2500);
    }
  }
};
</script>

<style lang="scss" scoped></style>
